import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa7e62e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-main"
};
import { watch } from 'vue';
import { useViewStore } from '@/store/module/view';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const route = useRoute();
    const viewStore = useViewStore();
    // const cachedViews = computed(() => viewStore.getCachedViews);
    watch(route, () => {
      viewStore.addCachedView(route);
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_RouterView, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_ctx.$route.meta?.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(route).name
        })) : _createCommentVNode("", true)], 1024)), !_ctx.$route.meta?.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(route).name
        })) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
});